import React from 'react';
import { Link } from 'react-router-dom';
import GradientBackground from '../home/GradientBackground';
import { APPS } from '../../data/appsData';
import s from '../../styles/AppsPage.module.css';

const AppleIcon = () => (
  <img src="/designs/icons/app-store-icon.png" alt="App Store" width="13" height="13" style={{ objectFit: 'contain' }} />
);

const AndroidIcon = () => (
  <img src="/designs/icons/google-play-icon.png" alt="Google Play" width="13" height="13" style={{ objectFit: 'contain' }} />
);

function AppCard({ app }) {
  return (
    <Link to={`/apps/${app.slug}`} className={s.card}>
      <div className={s.cardIcon} style={{ background: app.icon ? 'transparent' : app.accentColor }}>
        {app.icon
          ? <img src={app.icon} alt={app.name} className={s.cardIconImg} />
          : app.name.charAt(0)
        }
      </div>
      <div className={s.cardBody}>
        <h3 className={s.cardName}>{app.name}</h3>
        <p className={s.cardDesc}>{app.tagline}</p>
        <div className={s.cardStores}>
          {app.platforms.includes('ios') && (
            <span className={s.storeBadge}>
              <AppleIcon /> App Store
            </span>
          )}
          {app.platforms.includes('android') && (
            <span className={s.storeBadge}>
              <AndroidIcon /> Google Play
            </span>
          )}
        </div>
      </div>
      <svg className={s.cardArrow} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </Link>
  );
}

export default function AppsPage() {
  return (
    <>
      <GradientBackground />
      <div className={s.page}>
        <div className={s.hero}>
          <h1 className={s.title}>Our Apps</h1>
          <p className={s.subtitle}>
            {APPS.length} applications available on iOS and Android
          </p>
        </div>

        <div className={s.grid}>
          {APPS.map((app) => (
            <AppCard key={app.slug} app={app} />
          ))}
        </div>
      </div>
    </>
  );
}
